import React from 'react';
import bigLogoPresentation from '../../assets/images/big-logo-presentation.svg';
import useLanguage from '../../hooks/useLanguage';

const containerStyle = {
  position: 'fixed',
  inset: 0,
  backgroundColor: '#000000',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999
};

const imageStyle = {
  width: '32vw',
  maxWidth: '520px',
  minWidth: '220px',
  height: 'auto'
};

const DesktopSplashScreen = () => {
  const { t } = useLanguage();

  return (
    <div style={containerStyle}>
      <img
        src={bigLogoPresentation}
        alt={t('desktop.brand.logoAlt', { defaultValue: 'Loopino' })}
        style={imageStyle}
      />
    </div>
  );
};

export default DesktopSplashScreen;
